import { Map } from "immutable"

import {
    TOPIC_LIST_REQUEST as LIST_REQUEST,
    TOPIC_LIST_RESPONSE as LIST_RESPONSE,
    TOPIC_LIST_CACHED_RESPONSE as LIST_CACHED_RESPONSE,
    TOPIC_LIST_ERROR_RESPONSE as LIST_ERROR_RESPONSE
} from "../../actions/action-types"
import buildPagingReducer from "./build-paging-reducer"

export const defaultSearchCriteria = Map({
    name: ""
})

export default buildPagingReducer(
    {
        LIST_REQUEST,
        LIST_RESPONSE,
        LIST_CACHED_RESPONSE,
        LIST_ERROR_RESPONSE
    },
    defaultSearchCriteria
)
